import React from 'react';
import { Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    thumbnail: {
        width: theme.spacing(5),
        height: theme.spacing(4),
        borderRadius: theme.shape.borderRadius,
        objectFit: 'cover',
        background: theme.palette.action.hover
    }
});

const ImageElementThumbnail = ({ classes, imageUrl, dimmed }) => (
    <Box
        component='img'
        src={imageUrl}
        alt=''
        crossOrigin='anonymous'
        className={classes.thumbnail}
        style={{ opacity: dimmed ? 0.35 : 1 }}
    />
);

export default withStyles(ImageElementThumbnail, styles);
